<template>
  <div>
    <v-row>
      <v-col>
        <v-dialog v-model="dialog" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline"> Assign Routes/Subroutes </span>
            </v-card-title>
            <v-container
              class="pl-12 py-0"
              fluid
            >
            <v-row>
            <v-col cols="2" class="py-0">
              <v-radio-group v-model="transferAll" class="py-0">
                <v-radio
                  label="Transfer all to"
                  :value="true"
                ></v-radio>
                <v-radio
                  label="Assign individually"
                  :value="false"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="4" class="py-4">
              <div>
                <v-select
                  @change="existingRoutes(transferAllTo)"
                  v-model="transferAllTo"
                  :items="allUsers"
                  label="Transfer all to"
                  item-value="id"
                  class="added-receiver pt-0"
                  :disabled="!isTransferAllTo"
                >
                <template slot="append-outer">
                  <v-tooltip bottom v-if="hasRoutes == 1">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="green darken-2" v-bind="attrs" v-on="on">done</v-icon>
                    </template>
                    <span>Selected user does not have any existing routes/subroutes</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else-if="hasRoutes == 2">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="red darken-2" v-bind="attrs" v-on="on">close</v-icon>
                    </template>
                    <span>Selected user have existing routes/subroutes</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else-if="hasRoutes == 0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="grey darken-2" v-bind="attrs" v-on="on">help_outline</v-icon>
                    </template>
                    <span>Select a user that you want the route to be transferred.</span>
                  </v-tooltip>
                </template>
                  <template slot="selection" slot-scope="{ item }">
                    <!-- HTML that describe how select should render selected items -->
                    {{ item.first_name }}
                    {{ item.middle_name }}
                    {{ item.last_name }}

                    <span class="blue--text ml-2">
                      --
                      {{
                        item.positions[0]
                          ? item.positions[0].name
                          : " no position assigned "
                      }}
                    </span>
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    <!-- HTML that describe how select should render selected items -->
                    {{ item.first_name }}
                    {{ item.middle_name }}
                    {{ item.last_name }}

                    <span class="blue--text ml-2">
                      --
                      {{
                        item.positions[0]
                          ? item.positions[0].name
                          : " no position assigned "
                      }}
                    </span>
                  </template>
                </v-select>
              </div>
            </v-col>
            </v-row>
            </v-container>
            <v-card-text>
              <v-container>
                <v-list-item v-for="(route, main_index) in routes" :key="main_index">
                  <v-list-item-content class="pt-0 pb-0">
                    <v-row>
                      <v-col cols="8">
                        <v-list-item-title><b>Route Subject:</b> <a style="text-decoration: none;" target="_blank" :href="'/routes/' + route.id">{{route.subject}}</a></v-list-item-title>
                        <v-list-item-subtitle><b>Initiator:</b> <a style="text-decoration: none;" href="#">{{ route.user.first_name }} {{ route.user.middle_name }} {{ route.user.last_name}}</a></v-list-item-subtitle>
                      </v-col>
                      <v-col cols="4" class="pr-14">
                        <div v-if="userID == route.user_id">
                          <v-select
                            @change="checkRoutes({isMainRoute: 1, new_user_id: route.reassign_user_id, route_id: route.id})"
                            v-model="route.reassign_user_id"
                            :items="allUsers"
                            label="Transfer to"
                            item-value="id"
                            class="added-receiver pt-0"
                            :disabled="isTransferAllTo"
                          >
                          <template slot="append-outer">
                            <v-tooltip bottom v-if="route.hasRoutes == 1">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon color="green darken-2" v-bind="attrs" v-on="on">done</v-icon>
                              </template>
                              <span>Selected user does not have any existing routes/subroutes</span>
                            </v-tooltip>
                            <v-tooltip bottom v-else-if="route.hasRoutes == 2">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon color="red darken-2" v-bind="attrs" v-on="on">close</v-icon>
                              </template>
                              <span>Selected user have existing routes/subroutes</span>
                            </v-tooltip>
                            <v-tooltip bottom v-else-if="route.hasRoutes == 0">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon color="grey darken-2" v-bind="attrs" v-on="on">help_outline</v-icon>
                              </template>
                              <span>Select a user that you want the route to be transferred.</span>
                            </v-tooltip>
                          </template>
                            <template slot="selection" slot-scope="{ item }">
                              <!-- HTML that describe how select should render selected items -->
                              {{ item.first_name }}
                              {{ item.middle_name }}
                              {{ item.last_name }}

                              <span class="blue--text ml-2">
                                --
                                {{
                                  item.positions[0]
                                    ? item.positions[0].name
                                    : " no position assigned "
                                }}
                              </span>
                            </template>
                            <template slot="item" slot-scope="{ item }">
                              <!-- HTML that describe how select should render selected items -->
                              {{ item.first_name }}
                              {{ item.middle_name }}
                              {{ item.last_name }}

                              <span class="blue--text ml-2">
                                --
                                {{
                                  item.positions[0]
                                    ? item.positions[0].name
                                    : " no position assigned "
                                }}
                              </span>
                            </template>
                          </v-select>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="pb-0 pt-0">
                      <v-list-item-subtitle v-if="route.user_route_assignments.length > 0" >
                        <!-- <h4>Sub Routes:</h4> -->
                        <v-list-item v-for="(sub_route, sub_index) in route.user_route_assignments.filter(property => (property.user_id == userID && property.parent_id == null) || property.hasChildRoutes > 0)" :key="sub_index">
                          <v-list-item-content class="pt-0 pb-0">
                            <v-col cols="8">
                              <v-list-item-title><b>Action:</b> {{sub_route.action.name}}</v-list-item-title>
                              <v-list-item-subtitle><b>Assigned to:</b> <a style="text-decoration: none;" href="#">{{ sub_route.user.first_name }} {{ sub_route.user.middle_name }} {{ sub_route.user.last_name}}</a></v-list-item-subtitle>
                              <v-list-item-subtitle>
                                <v-btn
                                  elevation="2"
                                  small
                                  depressed
                                  color="primary"
                                  :href="'/routes/' + route.id + `#${sub_route.id}`"
                                  target="_blank"
                                >View</v-btn>
                              </v-list-item-subtitle>
                            </v-col>
                            <v-col cols="4" class="pl-5 pr-7">
                              <div v-if="userID == sub_route.user_id">
                                <v-select
                                  @change="checkRoutes({isMainRoute: 0, new_user_id: sub_route.reassign_user_id, route_id: sub_route.id})"
                                  v-model="sub_route.reassign_user_id"
                                  :items="allUsers"
                                  label="Transfer to"
                                  item-value="id"
                                  class="added-receiver pt-0"
                                  :disabled="isTransferAllTo"
                                >
                                  <template slot="append-outer">
                                    <v-tooltip bottom v-if="sub_route.hasRoutes == 1">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon color="green darken-2" v-bind="attrs" v-on="on">done</v-icon>
                                      </template>
                                      <span>Selected user does not have any existing routes/subroutes</span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-else-if="sub_route.hasRoutes == 2">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon color="red darken-2" v-bind="attrs" v-on="on">close</v-icon>
                                      </template>
                                      <span>Selected user have existing routes/subroutes</span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-else-if="sub_route.hasRoutes == 0">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon color="grey darken-2" v-bind="attrs" v-on="on">help_outline</v-icon>
                                      </template>
                                      <span>Select a user that you want the sub route to be transferred.</span>
                                    </v-tooltip>
                                  </template>
                                  <template slot="selection" slot-scope="{ item }">
                                    <!-- HTML that describe how select should render selected items -->
                                    {{ item.first_name }}
                                    {{ item.middle_name }}
                                    {{ item.last_name }}

                                    <span class="blue--text ml-2">
                                      --
                                      {{
                                        item.positions[0]
                                          ? item.positions[0].name
                                          : " no position assigned "
                                      }}
                                    </span>
                                  </template>
                                  <template slot="item" slot-scope="{ item }">
                                    <!-- HTML that describe how select should render selected items -->
                                    {{ item.first_name }}
                                    {{ item.middle_name }}
                                    {{ item.last_name }}

                                    <span class="blue--text ml-2">
                                      --
                                      {{
                                        item.positions[0]
                                          ? item.positions[0].name
                                          : " no position assigned "
                                      }}
                                    </span>
                                  </template>
                                </v-select>
                              </div>
                            </v-col>
                            <v-list-item-subtitle class="pl-3">
                              <v-list-item v-for="(child_route, child_index) in route.user_route_assignments.filter(property => property.parent_id == sub_route.id && property.user_id == userID)" :key="child_index">
                                <v-list-item-content class="pt-0 pb-0">
                                  <v-col cols="8">
                                    <v-list-item-title><b>Action:</b> {{child_route.action.name}}</v-list-item-title>
                                    <v-list-item-subtitle><b>Assigned to:</b> <a style="text-decoration: none;" href="#">{{ child_route.user.first_name }} {{ child_route.user.middle_name }} {{ child_route.user.last_name}}</a></v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                      <v-btn
                                        elevation="2"
                                        small
                                        depressed
                                        color="primary"
                                        :href="'/routes/' + route.id + `#${sub_route.id}`"
                                        target="_blank"
                                      >View</v-btn>
                                    </v-list-item-subtitle>
                                  </v-col>
                                  <v-col cols="4" class="pl-5">
                                    <div v-if="userID == child_route.user_id">
                                      <v-select
                                        @change="checkRoutes({isMainRoute: 0, new_user_id: child_route.reassign_user_id, route_id: child_route.id})"
                                        v-model="child_route.reassign_user_id"
                                        :items="allUsers"
                                        label="Transfer to"
                                        item-value="id"
                                        class="added-receiver pt-0"
                                        :disabled="isTransferAllTo"
                                      >
                                        <template slot="append-outer">
                                          <v-tooltip bottom v-if="child_route.hasRoutes == 1">
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-icon color="green darken-2" v-bind="attrs" v-on="on">done</v-icon>
                                            </template>
                                            <span>Selected user does not have any existing routes/subroutes</span>
                                          </v-tooltip>
                                          <v-tooltip bottom v-else-if="child_route.hasRoutes == 2">
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-icon color="red darken-2" v-bind="attrs" v-on="on">close</v-icon>
                                            </template>
                                            <span>Selected user have existing routes/subroutes</span>
                                          </v-tooltip>
                                          <v-tooltip bottom v-else-if="child_route.hasRoutes == 0">
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-icon color="grey darken-2" v-bind="attrs" v-on="on">help_outline</v-icon>
                                            </template>
                                            <span>Select a user that you want the sub route to be transferred.</span>
                                          </v-tooltip>
                                        </template>
                                        <template slot="selection" slot-scope="{ item }">
                                          <!-- HTML that describe how select should render selected items -->
                                          {{ item.first_name }}
                                          {{ item.middle_name }}
                                          {{ item.last_name }}

                                          <span class="blue--text ml-2">
                                            --
                                            {{
                                              item.positions[0]
                                                ? item.positions[0].name
                                                : " no position assigned "
                                            }}
                                          </span>
                                        </template>
                                        <template slot="item" slot-scope="{ item }">
                                          <!-- HTML that describe how select should render selected items -->
                                          {{ item.first_name }}
                                          {{ item.middle_name }}
                                          {{ item.last_name }}

                                          <span class="blue--text ml-2">
                                            --
                                            {{
                                              item.positions[0]
                                                ? item.positions[0].name
                                                : " no position assigned "
                                            }}
                                          </span>
                                        </template>
                                      </v-select>
                                    </div>
                                  </v-col>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-subtitle>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-divider></v-divider>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn color="blue darken-1" text @click="save" :disabled="disableTransferButton"
                >Transfer</v-btn
              >
              <!-- <v-btn color="blue darken-1" text @click="save" :disabled="disableTransfer"
                >Transfer</v-btn
              > -->
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from 'sweetalert2';
import LoadingOverlay from "../../common/LoadingOverlay.vue";

export default {
  name: "RouteAssignment",
  props: {
      dialog: Boolean,
      userID: Number,
  },
  components: {
    LoadingOverlay
  },
  data() {
    return {
        routes: [],
        loading: false,
        selectedUserId: null,
        transferData: [],
        transferDataToOneUser: [],
        notTransferrable: 0,
        disableTransfer: true,
        transferAll: true,
        transferAllTo: null,
        hasRoutes: 0,
    };
  },
  methods: {
    ...mapActions(["reAssignUsers"]),
    close() {
        this.$emit("closeDialog")
    },
    save(){ 
      let data = null
      if(this.transferAll){
        data = this.transferAlltoSelectedUsers(this.transferAllTo)
      }
      else{
        data = this.transferData
      }
      Swal.fire({
        title: "Do you wish to re-assign the routes?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, reassign it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          this.reAssignUsers(data).then(() => {
            this.loading = false
            this.close()
          })
        }
      });
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()]
    },
    existingRoutes(selected_id){
      try{
        this.getAllUsersRoutes.forEach(route => {  
          if(route.user_id == selected_id){
            throw 'Break'
          }
          route.user_route_assignments.forEach(subroute => {
            if(subroute.user_id == selected_id){
              throw 'Break'
            }
          })
        })
        throw 'No Routes Found'
      }catch(e){
        if(e == 'Break'){
          this.hasRoutes = 2
          this.disableTransfer = true;
        }else{
          this.hasRoutes = 1
          this.disableTransfer = false;
        }
      }
    },
    checkRoutes(payload){
      this.selectedUsers()
      try{
        this.getAllUsersRoutes.forEach(route => {  
          if(route.user_id == payload.new_user_id){
            throw 'Break'
          }
          route.user_route_assignments.forEach(subroute => {
            if(subroute.user_id == payload.new_user_id){
              throw 'Break'
            }
          })
        })
        throw 'No Routes Found'
      }catch(e){
        if(e == 'Break'){
          if(payload.isMainRoute){
            this.routes.forEach(route => {
              if(route.id == payload.route_id){
                if(route.hasRoutes !== 2)
                    this.notTransferrable++
                route.hasRoutes = 2
              }
            })
          }else{
            this.routes.forEach(route => {
              route.user_route_assignments.forEach(subroute => {
                if(subroute.id == payload.route_id){
                  if(subroute.hasRoutes !==2)
                    this.notTransferrable++
                  subroute.hasRoutes = 2
                }
              })
            })
          }
        }else{
          if(payload.isMainRoute){
            this.routes.forEach(route => {
              if(route.id == payload.route_id){
                if(this.notTransferrable > 0 && route.hasRoutes === 2)
                    this.notTransferrable--
                route.hasRoutes = 1
              }
            })
          }else{
            this.routes.forEach(route => {
              route.user_route_assignments.forEach(subroute => {
                if(subroute.id == payload.route_id){
                  if(this.notTransferrable > 0 && subroute.hasRoutes === 2)
                    this.notTransferrable--
                  subroute.hasRoutes = 1
                }
              })
            })
          }
        }
      }

      
      let new_routes = this.routes
      this.routes = []
      this.routes = new_routes
    },
    transferAlltoSelectedUsers(selected_id) {
      this.transferDataToOneUser = []
      this.routes.forEach(route => {
        if(route.user_id == this.userID){
          this.transferDataToOneUser.push({id: route.id, current_user_id: route.user_id, reassign_user_id: selected_id, isMainRoute: 1})
        }
        if(route.user_route_assignments.length > 0){
          route.user_route_assignments.forEach(subroute => {
            if(subroute.user_id == this.userID){
              this.transferDataToOneUser.push({id: subroute.id, current_user_id: subroute.user_id, reassign_user_id: selected_id, isMainRoute: 0})
            }
          })
        }
      })

      return this.transferDataToOneUser
    },
    selectedUsers() {
      this.transferData = []
      this.routes.forEach(route => {
        if(route.reassign_user_id){
          this.transferData.push({id: route.id, current_user_id: route.user_id, reassign_user_id: route.reassign_user_id, isMainRoute: 1})
        }
        if(route.user_route_assignments.length > 0){
          route.user_route_assignments.forEach(subroute => {
            if(subroute.reassign_user_id){
              this.transferData.push({id: subroute.id, current_user_id: subroute.user_id, reassign_user_id: subroute.reassign_user_id, isMainRoute: 0})
            }
          })
        }
      })

      return this.transferData
    }
  },
  computed: {
    ...mapGetters(["getAssignedSubRoute","getAssignedRoute","allUsers", "getAllUsersRoutes"]),
    isTransferAllTo() {
      return this.transferAll
    },
    disableTransferButton(){
      if(!this.transferAll)
        return this.notTransferrable > 0 || this.transferData.length < 1
      else 
        return this.disableTransfer
    }
  },
  watch: {
      dialog(){
          if(this.dialog){
            this.getAssignedSubRoute.forEach(item => {
              Object.assign(item.route, {reassign_user_id: null, hasRoutes: 0})
              item.route.user_route_assignments.forEach(i => {
                Object.assign(i, {reassign_user_id: null, hasRoutes: 0, hasChildRoutes: 0})
                if(i.parent_id !== null){
                  item.route.user_route_assignments.forEach(y => {
                    if(i.parent_id == y.id && i.user_id == this.userID){
                      y.hasChildRoutes = y.hasChildRoutes + 1
                    }
                  })
                }
              })
              this.routes.push(item.route)
            })
            this.getAssignedRoute.forEach((item) => {
              Object.assign(item, {reassign_user_id: null, hasRoutes: 0});
              item.user_route_assignments.forEach(i => {
                Object.assign(i, {reassign_user_id: null, hasRoutes: 0, hasChildRoutes: 0})
                if(i.parent_id !== null){
                  item.user_route_assignments.forEach(y => {
                    if(i.parent_id == y.id && i.user_id == this.userID){
                      y.hasChildRoutes = y.hasChildRoutes + 1
                    }
                  })
                }
              })
              this.routes.push(item)
            })
            this.routes = this.getUniqueListBy(this.routes, 'id');
            console.log(this.routes)
          }
      },
  }
  
};
</script>
